import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';


class BasvuruNedeniListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "BasvuruNedeniListe";
    super(baseUrl);
  }


  getBasvuruNedeniListeListe(basvuruNedeniKodu?: number){
    
        var request= new BasvuruNedeniListeListeRequest(basvuruNedeniKodu);
    return this.get("", request);
   
  }

}
export default new BasvuruNedeniListeAPI();
class BasvuruNedeniListeListeRequest {
  public basvuruNedeniKodu?: number;
 
  constructor(basvuruNedeniKodu?: number,) {
    this.basvuruNedeniKodu = basvuruNedeniKodu;

   
  }
}
export { BasvuruNedeniListeListeRequest };